import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';

import CampaignImageSlideCollection from '../components/campaign/CampaignImageSlideCollection.vue';

class CampaignImageSlideComponent {
  constructor({ container = '#campaign-image-slide-component', campaignMode = 'show' }) {
    this.app = null;
    this.container = container;
    this.campaignMode = campaignMode;
  }

  init() {
    const containerElement = this._getContainer();
    if (!containerElement) {
      throw new Error(`Image slide container not found: ${this.container}`);
    }

    try {
      // 創建 Vue 應用實例
      this.app = createApp(CampaignImageSlideCollection, {
        campaignMode: this.campaignMode
      });

      // 註冊 VueLazyload 插件
      this.app.use(VueLazyload, {
        preLoad: 2.6
      });

      // 掛載組件
      this.app.mount(containerElement);

      console.log('✅ CampaignImageSlideComponent initialized successfully');
    } catch (error) {
      console.error('❌ Failed to initialize CampaignImageSlideComponent:', error);
      throw error;
    }
  }

  destroy() {
    if (this.app) {
      try {
        this.app.unmount();
        this.app = null;
      } catch (error) {
        console.error('Failed to destroy CampaignImageSlideComponent:', error);
      }
    }
  }

  /**
   * 獲取容器元素
   * @private
   */
  _getContainer() {
    if (typeof this.container === 'string') {
      return document.querySelector(this.container);
    }
    return this.container;
  }
}

export default CampaignImageSlideComponent;